.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  font-family: var(--font-body);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text);
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-fast);
  cursor: pointer;
}

.button:hover:not(.copied):not(:disabled) {
  border-color: var(--color-primary);
  color: var(--color-primary);
  box-shadow: var(--shadow-md), var(--shadow-glow-primary);
}

.button:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.button.copied {
  background: var(--color-online);
  border-color: var(--color-online);
  color: var(--color-text-inverse);
  cursor: default;
}

.icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.sm {
  padding: var(--space-1) var(--space-3);
  font-size: 11px;
  min-height: 32px;
}

.md {
  padding: var(--space-2) var(--space-4);
  font-size: 12px;
  min-height: 40px;
}

.lg {
  padding: var(--space-3) var(--space-6);
  font-size: 13px;
  min-height: 48px;
}

/* Card variant */
.card {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
  overflow: hidden;
  transition: all var(--transition-fast);
}

.card:hover {
  border-color: var(--color-border-bright);
  box-shadow: var(--shadow-lg);
}

.cardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-3) var(--space-4);
  background: linear-gradient(180deg, rgba(255,255,255,0.04) 0%, transparent 100%);
  border-bottom: 1px solid var(--color-border-dim);
}

.cardLabel {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-dim);
}

.cardStatus {
  font-family: var(--font-body);
  font-size: 11px;
  color: var(--color-text-muted);
  transition: color var(--transition-fast);
}

.cardStatus.copied {
  color: var(--color-online);
  font-weight: 700;
}

.cardAddress {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-3) var(--space-4);
  cursor: pointer;
  transition: background var(--transition-fast);
  user-select: none;
}

.cardAddress:hover {
  background: var(--color-bg-panel-hover);
}

.cardAddress:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: -2px;
  border-radius: var(--radius-lg);
}

.addressText {
  font-family: var(--font-mono);
  font-size: 14px;
  color: var(--color-text);
  letter-spacing: 0.02em;
  word-break: break-all;
}

.copyIconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  margin-left: var(--space-3);
  color: var(--color-text-muted);
  background: var(--color-bg-input);
  border: 1px solid var(--color-border-dim);
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.copyIconWrapper.copied {
  color: var(--color-online);
  background: rgba(90, 166, 66, 0.15);
  border-color: var(--color-online);
}

.copyIconWrapper:hover:not(.copied) {
  color: var(--color-primary);
  border-color: var(--color-primary);
}

.icon {
  width: 16px;
  height: 16px;
}

/* Card sizes */
.card.sm .addressText { font-size: 12px; }
.card.md .addressText { font-size: 14px; }
.card.lg .addressText { font-size: 16px; }